import { render, staticRenderFns } from "./BulkActionsHeader.vue?vue&type=template&id=66d37fcf"
import script from "./BulkActionsHeader.vue?vue&type=script&lang=js"
export * from "./BulkActionsHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports